module.exports = "img/notif-slider.e648344.svg";